import React, { useEffect, useState } from "react";
import { auth, googleProvider } from "../lib/firebase";
import { signInWithPopup, onAuthStateChanged, signOut } from "firebase/auth";
import { getUserRole, requestAccess } from "../lib/config";
import { useNavigate } from "react-router-dom";

function HomePage() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userStatus, setUserStatus] = useState(null); // null | 'approved' | 'pending' | 'none'
    const [requesting, setRequesting] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const unsub = onAuthStateChanged(auth, async (u) => {
            setUser(u);
            if (u) {
                const role = await getUserRole(u.uid);
                if (role && role.status === "approved") {
                    setUserStatus("approved");
                    navigate("/dashboard");
                } else if (role && role.status === "pending") {
                    setUserStatus("pending");
                } else {
                    setUserStatus("none");
                }
            } else {
                setUserStatus(null);
            }
            setLoading(false);
        });
        return unsub;
    }, [navigate]);

    async function handleLogin() {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const role = await getUserRole(result.user.uid);
            if (role && role.status === "approved") {
                navigate("/dashboard");
            } else if (role && role.status === "pending") {
                setUserStatus("pending");
            } else {
                setUserStatus("none");
            }
        } catch (err) {
            console.error("Login failed:", err);
        }
    }

    async function handleRequestAccess() {
        if (!user) return;
        setRequesting(true);
        try {
            await requestAccess(user);
            setUserStatus("pending");
        } catch (err) {
            console.error("Request failed:", err);
        }
        setRequesting(false);
    }

    if (loading) {
        return (
            <div className="home-page">
                <div className="home-card">
                    <div className="loading-spinner" />
                </div>
            </div>
        );
    }

    return (
        <div className="home-page">
            <div className="home-card">
                <div className="home-icon">🚇</div>
                <h1 className="home-title">MTA Time</h1>
                <p className="home-subtitle">Real-time subway & bus arrivals</p>
                {!user ? (
                    <button className="google-btn" onClick={handleLogin}>
                        <svg viewBox="0 0 24 24" width="20" height="20" style={{ marginRight: 10, verticalAlign: "middle" }}>
                            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
                            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                        </svg>
                        Sign in with Google
                    </button>
                ) : userStatus === "approved" ? (
                    <div className="home-user-info">
                        <p>Signed in as <strong>{user.displayName}</strong></p>
                        <button className="primary-btn" onClick={() => navigate("/dashboard")}>
                            Go to Dashboard
                        </button>
                        <button className="text-btn" onClick={() => signOut(auth)}>Sign out</button>
                    </div>
                ) : userStatus === "pending" ? (
                    <div className="home-user-info">
                        <p>Signed in as <strong>{user.displayName}</strong></p>
                        <div style={{
                            background: '#fef3cd', color: '#856404', padding: '16px 20px',
                            borderRadius: 12, marginTop: 12, fontSize: '0.95rem', textAlign: 'center'
                        }}>
                            ⏳ Your access request is pending approval.
                        </div>
                        <button className="text-btn" style={{ marginTop: 12 }} onClick={() => signOut(auth)}>Sign out</button>
                    </div>
                ) : (
                    <div className="home-user-info">
                        <p>Signed in as <strong>{user.displayName}</strong></p>
                        <button
                            className="primary-btn"
                            onClick={handleRequestAccess}
                            disabled={requesting}
                            style={{ marginTop: 8 }}
                        >
                            {requesting ? "Requesting..." : "🔑 Request Access"}
                        </button>
                        <button className="text-btn" style={{ marginTop: 8 }} onClick={() => signOut(auth)}>Sign out</button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default HomePage;
